import { z } from "zod";

import { PluginConfigType } from "../../../schemas/plugin";

export const GetSinglePreviewRequestPathParamSchema = z.object({
  experienceId: z.string().uuid(),
  organizationId: z.string().uuid(),
});

export type GetSinglePreviewRequestPathParamType = z.infer<
  typeof GetSinglePreviewRequestPathParamSchema
>;

export const GetSinglePreviewResponseBodySchema = z.any().nullable();
export type GetSinglePreviewResponseBodyType = PluginConfigType | null;
